import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ItemReportContent from '../ItemReportContent';
import { setFromDate, setToDate, setSelectedBranch, fetchItemFullReport } from '../../../store/slices/itemReportSlice';

const ItemReport = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';
    const storedBranchName = localStorage.getItem('branchname') || 'Current Branch';

    useEffect(() => {
        const today = new Date();
        dispatch(setFromDate(today));
        dispatch(setToDate(today));
        dispatch(setSelectedBranch({ branch_id: storedBranchId, branch_name: storedBranchName }));
        dispatch(
            fetchItemFullReport({
                fromDate: today,
                toDate: today,
                branchId: storedBranchId
            })
        );
    }, [dispatch, storedBranchId, storedBranchName]);

    return <ItemReportContent isManagerView />;
};

export default ItemReport;
